import { apiFetch, publicApiFetch } from './fetch';

export type DocumentDeletionAckDto = {
  id: string;
  recipientId: string | null;
  recipientName: string;
  emailDisplay: string;
  status: string;
  channel: string;
  notifiedAt: string;
  confirmedAt: string | null;
  declinedAt: string | null;
};

export type DocumentDeletionRequestDto = {
  id: string;
  documentId: string;
  kind: string;
  status: string;
  reason: string | null;
  requestedAt: string;
  expiresAt: string;
  completedAt: string | null;
  keepMonitoring: boolean;
  acknowledgements: DocumentDeletionAckDto[];
};

export type PublicErasureInfoDto = {
  documentDisplayName: string;
  senderDisplayName: string;
  attestationText: string;
  status: string;
  expiresAt: string;
  canConfirm: boolean;
  canDecline: boolean;
};

export async function createDocumentDeletionRequest(
  documentId: string,
  body?: { reason?: string; recipientIds?: string[] },
): Promise<DocumentDeletionRequestDto> {
  const res = await apiFetch(`/api/documents/${documentId}/deletion-requests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
  if (!res.ok) {
    throw new Error(`Failed to create deletion request (${res.status})`);
  }
  return res.json() as Promise<DocumentDeletionRequestDto>;
}

export async function fetchDocumentDeletionRequests(
  documentId: string,
): Promise<DocumentDeletionRequestDto[]> {
  const res = await apiFetch(`/api/documents/${documentId}/deletion-requests`);
  if (!res.ok) {
    throw new Error(`Failed to fetch deletion requests (${res.status})`);
  }
  return res.json() as Promise<DocumentDeletionRequestDto[]>;
}

export async function ownerDeleteDocument(
  documentId: string,
  body?: { password?: string; mfaCode?: string },
): Promise<void> {
  const res = await apiFetch(`/api/documents/${documentId}/owner-delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
  if (!res.ok) {
    throw new Error(`Failed to owner-delete document (${res.status})`);
  }
}

export async function fetchPublicErasureInfo(token: string): Promise<PublicErasureInfoDto> {
  const res = await publicApiFetch(`/api/public/erasure/${token}`);
  if (!res.ok) {
    throw new Error(`Failed to load erasure info (${res.status})`);
  }
  return res.json() as Promise<PublicErasureInfoDto>;
}

export async function confirmPublicErasure(token: string): Promise<void> {
  const res = await publicApiFetch(`/api/public/erasure/${token}/confirm`, { method: 'POST' });
  if (!res.ok) {
    throw new Error(`Failed to confirm erasure (${res.status})`);
  }
}

export async function declinePublicErasure(token: string): Promise<void> {
  const res = await publicApiFetch(`/api/public/erasure/${token}/decline`, { method: 'POST' });
  if (!res.ok) {
    throw new Error(`Failed to decline erasure (${res.status})`);
  }
}
